import React from 'react';
import '../../App.css';
import { Collapse } from 'antd';
const { Panel } = Collapse;

function FAQ() {
    return (
        <div className='container'>
            <div className='row my-5 flex-column'>
                <h1 className='subheader36 green-text'>Frequently Asked Questions</h1>
                <br />
                <Collapse defaultActiveKey={['1']} ghost expandIconPosition={"end"}>
                    <Panel header="How does Bubble work?" key="1">
                    <p>{"Bubble is a social co-living platform that connects renters with affordable and comfortable accommodation by offering rental properties and roommates. For tenants, it provides a renting platform with social features that lets customers rent affordable homes easily and find roommates to split rent with. For landlords, Bubble makes renting out properties faster and easier by screening tenants, handling home viewings, providing 24/hrs communication with tenants and rent collection, and reducing the time spent on renting out properties."}</p>
                    </Panel>
                    <Panel header="How do I create an account?" key="2">
                    <p>{"To create an account on Bubble, go to the Bubble website and click on the 'Sign Up' button on the top right corner of the homepage. Fill in your details and follow the instructions on the page."}</p>
                    </Panel>
                    <Panel header="How do I book a viewing?" key="3">
                    <p>{"To book a viewing, log in to your Bubble account, search for the rental property you're interested in, and select 'Book a Viewing' on the property's listing page. Choose a suitable time and date, and then submit your request. Bubble Africa will get back to you to confirm the viewing details."}</p>
                    </Panel>
                    <Panel header="How do I list a space?" key="4">
                    <p>{"To list a space on Bubble, create an account on the website, and click on the 'List a Space' button on the top right corner of the homepage. Fill in the details of the space and follow the instructions on the page."}</p>
                    </Panel>
                    <Panel header="How do I book a viewing?" key="5">
                    <p>{"To book a viewing, log in to your Bubble account, search for the rental property you're interested in, and select 'Book a Viewing' on the property's listing page. Choose a suitable time and date, and then submit your request. Bubble Africa will get back to you to confirm the viewing details."}</p>
                    </Panel>
                </Collapse>
            </div>
            
        </div>
    )
}

export default FAQ;

